<script>
    import app from './stores/app';
    import error from "./stores/error";
    import {getClientCreditsHistory,ClientCreditsHistorySave} from "./requests";
    import TableHeader from './controls/TableHeader.svelte';
    import ClientCreditsHistoryRow from './ClientCreditsHistoryRow.svelte';

    let client = null;
    let historyList= [];
    let totalPrice = 0;
    let totalPayment = 0;
    let totalRest = 0;
    let initialized = false;

    let table_columns = [
        {key: 'date_created', name: 'Ημερομηνία', sortable: true, sort_way: '', align: ''},
        {key: 'credits', name: 'Μονάδες', sortable: true, sort_way: 'ASC', align: ''},
        {key: 'credit_price', name: 'Τιμή μονάδας', sortable: true, sort_way: '', align: ''},
        {key: 'total_price', name: 'Σύνολο', sortable: true, sort_way: '', align: ''},
        {key: 'invoice', name: 'Τιμολόγιο', sortable: true, sort_way: '', align: ''},
        {key: 'payed', name: 'Πληρώθηκε', sortable: true, sort_way: '', align: ''},
        {key: 'notes', name: 'Σημειώσεις', sortable: true, sort_way: '', align: ''},
    ];

    const close = () => {
        initialized = false;
        client = null;
        historyList = [];
        $app.selectedCreditsHistoryId = 0;
        app.clientCreditsHistory(null);
    }

    const load = async (key = null, sort_way = null) => {
        const [err, res] = await getClientCreditsHistory({ key, sort_way, id:client.id });

        historyList = res.list;

        calculateTotals();
    }

    const save = async(entry) => {
        const [err, res] = await ClientCreditsHistorySave(entry);
        if (err) {
            error.show(err);
        } else {
            //success.show("Το ιστορικό ενημερώθηκε.");
            calculateTotals();
        }
    }

    const initialize = () => {
        client = $app.creditsHistoryClient;
        if (client === undefined || client === null) {
            client = null;
        }
        if (client !== undefined && client !== null && client.id > 0 && !initialized) {
            load();
            initialized = true;
        }
    }

    const calculateTotals = () => {
        totalPrice = 0;
        totalPayment = 0;
        totalRest = 0;
        historyList.map(item => {
            if (item.payed && parseInt(item.payed) > 0) {
                totalPayment+= parseFloat(item.total_price, 2);
            }
            totalPrice+= parseFloat(item.total_price, 2);
        });
        totalRest = parseFloat(totalPrice - totalPayment).toFixed(2);
        totalPrice = totalPrice.toFixed(2);
        totalPayment = totalPayment.toFixed(2);
    }

    const onEntryChange = ({detail}) => {
        save(detail);
    }

    const onSort = ({detail:column}) => {
        load(column.key, column.sort_way);
    }

    $: {
        initialize($app.creditsHistoryClient);
    }

</script>

{#if client !== null}
    <div class="popup-overlay visible">
        <div class="modal modal-xl">
            <div class="modal-header">
                <div class="modal-title">
                    Ιστορικό Μονάδων: { client.lastname } { client.name }
                </div>
                <div class="controls-right">
                    <span on:click="{ close }"><i class="fa fa-times"></i></span>
                </div>
            </div>
            <div class="modal-body">
                {#if historyList.length}
                    <div class="table-responsive mrg-b-sm">
                        <table class="table table-bordered table-list table-data mrg-b-none">
                            <TableHeader table_columns="{ table_columns }" on:sort="{ onSort }"/>
                            <tbody>
                            {#each historyList as entry}
                                <ClientCreditsHistoryRow entry="{ entry }" on:entry_change="{ onEntryChange }" />
                            {/each}
                            </tbody>
                        </table>
                    </div>
                    <div class="mrg-b-lg">
                        Σύνολο: <strong>{ totalPrice }</strong>, Πληρωμή: <strong>{ totalPayment }</strong>
                        {#if totalRest > 0}
                            , Υπόλοιπο: <strong>{ totalRest }</strong>
                        {/if}
                    </div>
                {:else}
                    <div class="panel-body">
                        <p>Δεν υπάρχει ιστορικό μονάδων</p>
                    </div>
                {/if}
                <div class="text-right">
                    <button class="btn btn-default" on:click="{ close }">Κλείσιμο</button>
                </div>
            </div>
        </div>
    </div>
{/if}

